import { LEVELS } from "pages/Tenis10Claims/claimsLabels"

// A Tenis10 event (PRD 16 LR11, the LR10 canvas verdict E-C / K-B): a tennis event of the Tenis10 programme, chosen at creation as the Sport
// select's third choice. Its competitions are named by their Tenis10 category — a colour level with one of its age categories
// (ADR-0001, the glossary's „Age category”) — and not by the adult level.
export const TENIS10 = "tenis10"
export const isTenis10Event = event => event?.programType === TENIS10
// The club's default event images an event takes (Marian 2026-10-29; sportya-api common/eventEditing `eventDefaultImagesKey`,
// re-encoded): its category's set, a Tenis10 event the club's Tenis10 set of the category, kept apart in `tenis10-{category}`.
export const eventDefaultImagesKey = ({ programType, category } = {}) => programType === TENIS10 ? `${TENIS10}-${category}` : category
// The Sportya Tenis10 image of a category and kind (logo, featured, cover): the one a Tenis10 event shows without its own image or the
// club's (ADR-0021; the web's `public/assets/images/placeholders`, read by its eventImages.ts).
export const tenis10FallbackImageUrl = (category, kind) =>
  `${process.env.REACT_APP_WEB_URL}/assets/images/placeholders/${TENIS10}-${category}-${kind}.png`
// The Tenis10 participation package every Tenis10 event starts with (Tudor, 2026-10-24): a bottle of water for each child at the event and
// the match balls for every level. Written in Romanian, the original the API translates into the other languages.
export const TENIS10_PLAYER_PACKAGE = {
  title: "Pachet de Participare Tenis10 (Gratuit)",
  summary: "Apă și mingi de joc pentru fiecare copil",
  description: "Pachetul de participare Tenis10 conține:\n- o sticlă de apă pentru fiecare copil, la eveniment;\n- mingile de joc, pentru toate nivelurile (Roșu, Portocaliu, Verde, Galben).",
}

// The ages an age category admits, as the age a child reaches by 31 December of the competition's start year: at most `max`, and U14 at
// least 13 (common/tenis10Eligibility). Open has no age limit of its own below the Under-16 threshold, so up to 15.
const AGE_CATEGORIES = { U8: { max: 8 }, U9: { max: 9 }, U10: { max: 10 }, U12: { max: 12 }, U14: { min: 13, max: 14 }, Open: { max: 15 } }
const agesText = ({ min, max }) => min ? `${min}–${max}` : `up to ${max}`

export const tenis10CategoryLabel = ({ tenis10Level, ageCategory } = {}) => `${LEVELS[tenis10Level] || tenis10Level || "—"} · ${ageCategory || "—"}`
// „Verde · U10 (up to 10)”: a category as the editor offers it.
export const tenis10CategoryOption = category => `${tenis10CategoryLabel(category)} (${agesText(AGE_CATEGORIES[category.ageCategory] || {})})`
// The category a select holds, as one value.
export const tenis10CategoryKey = ({ tenis10Level, ageCategory } = {}) => tenis10Level && ageCategory ? `${tenis10Level}-${ageCategory}` : ""
export const tenis10CategoryFrom = key => {
  const [tenis10Level, ageCategory] = String(key || "").split("-")
  return tenis10Level && ageCategory ? { tenis10Level, ageCategory } : null
}
// PRD 16 LR11b (register E35, E42 (6)): where a category stands in the catalogue — colour by colour (Roșu → Galben), then age by age —, a
// colour or an age the catalogue does not know after the known ones; NaN for a competition without a colour (an adult one).
const LEVEL_ORDER = ["rosu", "portocaliu", "verde", "galben"]
const AGE_ORDER = Object.keys(AGE_CATEGORIES)
const rankIn = (order, value) => order.includes(value) ? order.indexOf(value) : order.length
export const tenis10CategoryRank = ({ tenis10Level, ageCategory } = {}) => tenis10Level
  ? rankIn(LEVEL_ORDER, tenis10Level) * (AGE_ORDER.length + 1) + rankIn(AGE_ORDER, ageCategory)
  : NaN
// „Born in 2012–2013 (U14: 13–14 by 31 December 2026)”: the birth years a category admits in the competition's start year.
export const tenis10AgesText = (ageCategory, year) => {
  const ages = AGE_CATEGORIES[ageCategory]
  if (!ages || !Number.isInteger(year)) return ""
  const born = ages.min ? `Born in ${year - ages.max}–${year - ages.min}` : `Born in ${year - ages.max} or later`
  return `${born} (${ageCategory}: ${agesText(ages)} by 31 December ${year})`
}
